import React, { useEffect, useState } from "react";
import Close from "../../assets/Modal-Close-Icon.svg";
import Drop from "../../assets/Polygon 2.svg";
import "./MultipleAssign.css";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux-store/store";
import {
  GetAllNotification_M3,
  UpdateAssignToNotification,
} from "../../../../api/notifyapi/Notifyapi";
import {
  IFilterModel,
  NotificationActions,
} from "../../../../slices/NotificationSlice";
import { IAssignList } from "../../../../slices/UserControlSlice";
import { Tooltip } from "antd";
import { LEVEL_CONSTANT } from "../CreateAndEditNotify/FormDataConstants";
import Loader from "../../loader/Loader";
import { getAssignBtnTooltip } from "../../TooltipContent/tooltipMessageHelper";

const AssignNotification: React.FC = () => {
  const { user, features, switchRole } = useSelector(
    (state: RootState) => state.user
  );

  const UserAssignList = useSelector(
    (state: RootState) => state.userControl.UserAssignList
  );
  const [toggleAssign, setToggleAssign] = useState<boolean>(false);
  const [selectedAssignUser, setSelectedAssignUser] = useState<IAssignList[]>(
    []
  );
  const { searchFilter } = useSelector(
    (state: RootState) => state.notification
  );
  const data = useSelector((state: RootState) => state.notification.editData);
  const dispatch = useDispatch<AppDispatch>();
  const [userRole, setUserRole] = useState<string[]>([]);
  const [isAssignButtonDisabled, setIsAssignButtonDisabled] =
    useState<boolean>(true);
  const [previouslyAssignedUser, setPreviouslyAssignedUser] = useState<
    string | null
  >(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    if (user) {
      setUserRole(user?.ssoRoles.map((role: string) => role));
    }
  }, [user]);

  useEffect(() => {
    if (data) {
      // Check if this notification was previously assigned
      const hasAssignedUser = data.assignedUser && data.assignedUser[0];

      if (hasAssignedUser) {
        // Store the previously assigned user email
        setPreviouslyAssignedUser(hasAssignedUser);

        // Find and set the previously assigned user details
        if(UserAssignList !==null) {
          const assigneeDetails = UserAssignList.find(
            (item) => item.emailID === hasAssignedUser
          );
          if (assigneeDetails) {
            setSelectedAssignUser([
              {
                emailID: assigneeDetails.emailID,
                name: assigneeDetails.name,
                userID: assigneeDetails.userID,
              },
            ]);
          }
        }
       
      } else {
        // Clear selection for new assignments
        setSelectedAssignUser([]);
        setPreviouslyAssignedUser(null);
      }
    }
  }, [data, UserAssignList]);

  const handleclose = (): void => {
    dispatch(NotificationActions.UpdateEnableAssign(false));
  };

  const handleAssignToggle = (): void => {
    setToggleAssign(!toggleAssign);
  };
  const handleAssignUser = (user: IAssignList): void => {
    setSelectedAssignUser([user]);
    setToggleAssign(!toggleAssign);
  };

  const handleToAssignUser = (): void => {
    try {
      setIsLoading(true);
      if (data) {
        dispatch(
          UpdateAssignToNotification({
            assignee: selectedAssignUser.map(
              (item: IAssignList) => item.emailID
            ),
            notificationIDs: [data.notificationID],
            performedBy: user ? user.email : "",
          })
        ).then(() => {
          dispatch(NotificationActions.UpdateEnableAssign(false));
          dispatch(NotificationActions.updateIsAssigned(true));
          if (searchFilter.globalSearch.value) {
            let lQuery: IFilterModel = {
              filters: searchFilter.globalSearchApiQuery.filters,
              isAscending: false,
              currentPageSize: searchFilter.apiQuery.currentPageSize,
              pageSize: searchFilter.apiQuery.pageSize,
              page: 1, //First time always get page 1
              isOr: true,
              isPageChanged: "",
              sortField: "",
            };

            dispatch(GetAllNotification_M3(lQuery));
          } else {
            dispatch(GetAllNotification_M3(searchFilter.apiQuery));
          }
          setIsLoading(false);
        });
      }
      setPreviouslyAssignedUser(selectedAssignUser[0].emailID);
    } catch (error) {
      console.error("Error assigning user:", error);
    }
  };

  // Check the button should be disabled based on user roles and notification levels
  useEffect(() => {
    const hasLevel1 = data?.level === LEVEL_CONSTANT.level1;
    const hasLevel2 = data?.level === LEVEL_CONSTANT.level2;

    setIsAssignButtonDisabled(
      !(
        (hasLevel1 && features.notification.assignNotify.level1) ||
        (hasLevel2 && features.notification.assignNotify.level2)
      )
    );
  }, [data, userRole, features]);

  return (
    <div className="modal-overlay">
      <div className="multipleAssign-modal-content">
        <div className="modal-header">
          <span className="popup-head">
            {previouslyAssignedUser ? "Reassign User" : "Assign User"}
          </span>
          <img
            src={Close}
            alt="assign-close-icon"
            className="close-btn"
            tabIndex={0}
            onClick={handleclose}
          />
        </div>
        <div className="modal-body-main-container">
          <div className="multipleAssign-modal-footer">
            <div style={{ padding: "0 26px" }}>
              <div className="assign-user-input-container">
                <div className="label-element">
                  {previouslyAssignedUser ? "Select New User" : "Select User"}
                </div>
                <div
                  className="assign-user-select-container"
                  onClick={handleAssignToggle}
                >
                  <span className="dropdown-spanElement">
                    {selectedAssignUser.length > 0
                      ? selectedAssignUser
                          .map((item: IAssignList) => item.name)
                          .join(", ")
                      : "Select the Assign User"}
                  </span>
                  <img src={Drop} alt="DropDown-Icon" />
                </div>
              </div>
              {toggleAssign && (
                <div className="assign-user-dropdown-container">
                  {UserAssignList.map((user, index) => (
                    <div key={index}>
                      <div
                        className="dropdownList-container"
                        onClick={() => handleAssignUser(user)}
                      >
                        {user.name}
                        {user.emailID === previouslyAssignedUser && (
                          <span className="current-assignee"> (Current)</span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div
              className="label-element"
              style={{ marginTop: "4px", marginLeft: "27px" }}
            >
              {previouslyAssignedUser
                ? `Currently assigned to: ${selectedAssignUser[0]?.name || ""}`
                : "You can assign one user at a time"}
            </div>
            <div className="multipleAssign-footer-btn">
              <Tooltip title={getAssignBtnTooltip(data, user, switchRole)}>
                <button
                  disabled={
                    selectedAssignUser.length === 0 || isAssignButtonDisabled
                  }
                  className={`popup-create-btn ${
                    isAssignButtonDisabled ? "disabled-button-style" : ""
                  }`}
                  onClick={() => {
                    if (!isAssignButtonDisabled) {
                      handleToAssignUser();
                    }
                  }}
                >
                  {isLoading ? (
                    <Loader />
                  ) : previouslyAssignedUser ? (
                    "Reassign"
                  ) : (
                    "Assign"
                  )}
                </button>
              </Tooltip>
              <button className="popup-Cancel-btn" onClick={handleclose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AssignNotification;
